export interface ICity {
  id: string;
  name: string;
  countryId: string;
  isPublished: boolean;
  images: Array<{ type: number; imageUrl: string; }>;
}
